import React, { useEffect } from "react";
import FormHomePage from "./forms";
import Aos from "aos";
import "aos/dist/aos.css"


function HomePage() {
    useEffect(() => {
        Aos.init({
            duration: 1000,
            easing: 'ease-in',
            offset: 200,
        })
    })
    return (
        <div>
            <section className="main-content">
                <picture>
                    <source srcSet="../images/logo.webp" type="image/webp"></source>
                    <source srcSet="../images/logo-min.png" type="image/png"></source>
                    <img data-aos="flip-right" className="logo-img" src="../images/logo-min.png" alt="DataHedge-logo"></img>
                </picture>
                <h2 className="font-normal tag-line">INDIA'S ONLY AI BASED TRADING DESK</h2>
                <div data-aos="fade-up" className="form-container .fade-in-up">
                    <h2 className="font-normal">Subscribe to our News letter</h2>
                    <FormHomePage ></FormHomePage>
                </div>
            </section>
            <section data-aos="fade-up" className="track-record">
                <h1 className="font-normal">Track record</h1>
                <ul className="records">
                    <li className="record font-normal">Developed our first trading algorithm</li>
                    <li className="record-date font-normal">- March 2020</li>
                    <li className="record font-normal">Integrated with Kredent Trading Desk</li>
                    <li className="record-date font-normal">- June 2021</li>
                    <li className="record font-normal">Handling 2Cr. for HNI clients</li>
                    <li className="record-date font-normal">- October 2021</li>
                </ul>
            </section>
            <section data-aos="fade-right" className="adapt">
                <h1 className="section-heading">Adaptability</h1>
                <picture>
                    <source srcSet="../images/zerodha.webp" type="image/webp"></source>
                    <source srcSet="../images/zerodha-min.png" type="image/png"></source>
                    <img className="img-logo-comp" src="../images/zerodha-min.png" alt="zerodha"></img>
                </picture>
                <picture>
                    <source srcSet="../images/ab.webp" type="image/webp"></source>
                    <source srcSet="../images/ab-min.png" type="image/png"></source>
                    <img className="img-logo-comp" src="../images/ab.png" alt="alice-blue"></img>
                </picture>
                <picture>
                    <source srcSet="../images/kotak.webp" type="image/webp"></source>
                    <source srcSet="../images/kotak-min.png" type="image/png"></source>
                    <img className="img-logo-comp" src="../images/kotak-min.png" alt="kotak"></img>
                </picture>
                <picture>
                    <source srcSet="../images/angel-broking.webp" type="image/webp"></source>
                    <source srcSet="../images/angel-broking-min.png" type="image/png"></source>
                    <img className="img-logo-comp" src="../images/angel-broking-min.png" alt="angel-broking"></img>
                </picture>
                <picture>
                    <source srcSet="../images/upstocks.webp" type="image/webp"></source>
                    <source srcSet="../images/upstocks-min.png" type="image/png"></source>
                    <img className="us img-logo-comp" src="../images/upstocks-min.png" alt="upstocks"></img>
                </picture>

            </section>
            <section data-aos="fade-up" className="ma">
                <h1 className="section-heading">Market Analysis</h1>
                <p className="context-title ma-content">As you can see in the daily volume graph, most of the turnover in Indian
                    markets is
                    in the futures and options segment followed by equity and crypto. So our major focus will be on
                    developing algorithms for these F&O traders. We will also make algorithms for other segments but F&O
                    will be on top of our list.</p>
                <div className="image-container">
                    <picture>
                        <source srcSet="../images/graph.webp" type="image/webp"></source>
                        <source srcSet="../images/graph-min.png" type="image/png"></source>
                        <img src=" ../images/graph-min.png" className="image-graph" alt="Graph of profits"></img>
                    </picture>
                    <h1>11.1% CAGR</h1>
                </div>
            </section>
            <section className="cn">
                <h1 data-aos="fade-up" className="section-heading">Ground reality</h1>
                <div data-aos="fade-up" className="tile">
                    <picture>
                        <source srcSet="../images/investment.webp" type="image/webp"></source>
                        <source srcSet="../images/investment-min.png" type="image/png"></source>
                        <img src=" ../images/investment-min.png" alt="increment" className="sol-img"></img>
                    </picture>
                    <p className="context-description">The total number of retail investors increased by an astonishing 14.2
                        million in FY21</p>
                </div>
                <div data-aos="fade-up" className="tile flip">
                    <picture>
                        <source srcSet="../images/stock.webp" type="image/webp"></source>
                        <source srcSet="../images/stock-min.jpg" type="image/png"></source>
                        <img src=" ../images/stock-min.jpg" alt="Stocks-increment" className="stock flip"></img>
                    </picture>
                    <p className="context-description">The NSE alone saw retail investors share grow from 35% in 2017 to 45% in
                        2021.</p>
                </div>
                <div data-aos="fade-up" className="tile">
                    <picture>
                        <source srcSet="../images/graph-increment.webp" type="image/webp"></source>
                        <source srcSet="../images/graph-increment-min.jpg" type="image/png"></source>
                        <img src=" ../images/graph-increment-min.jpg" alt="increment-in algo trade" className="sol-img"></img>
                    </picture>
                    <p className="context-description">The global algorithmic trading market size to grow from USD 11.1 billion
                        in 2019 to USD 18.8 billion by 2024, at a Compound Annual Growth Rate (CAGR) of 11.1%</p>
                </div>
                <div data-aos="fade-up" className="tile flip">
                    <picture>
                        <source srcSet="../images/indian-investers.webp" type="image/webp"></source>
                        <source srcSet="../images/indian-investers-min.jpg" type="image/png"></source>
                        <img src=" ../images/indian-investers-min.jpg" alt="indian investers are increasing" className="sol-img"></img>
                    </picture>
                    <p className="context-description">India still continues to be an under penetrated market with just about 4
                        percent of the population having Demat accounts as compared to 11 percent in China and more than 32
                        percent in the USA. Therefore, the potential for growth is massive</p>
                </div>

            </section>
            <section className="solution">
                <h1 data-aos="fade-up" className="section-heading">Our Solution</h1>
                <div data-aos="fade-up" className="context">
                    <picture>
                        <source srcSet="../images/algo.webp" type="image/webp"></source>
                        <source srcSet="../images/algo-min.png" type="image/png"></source>
                        <img src=" ../images/algo-min.png" alt="algo" className="sol-img"></img>
                    </picture>
                    <div className="context-box">
                        <p className="context-title">Conventional trading algos are old</p>
                        <p className="context-description">The normal trading methods don't evolve with time but the machine
                            learning algorithms we develop change the process of trading according to the market situations
                        </p>
                    </div>
                </div>
                <div data-aos="fade-up" className="context flip">
                    <picture>
                        <source srcSet="../images/ai.webp" type="image/webp"></source>
                        <source srcSet="../images/algo-min.jpg" type="image/png"></source>
                        <img className="sol-img" src=" ../images/ai-min.jpg" alt="ai-image"></img>
                    </picture>
                    <div className="context-box">
                        <p className="context-title">Trading & Machine Learning are complex to understand</p>
                        <p className="context-description">
                            Learning both TA and ML and integrating both of them to make trading algorithms is a complicated
                            and
                            time taking process.</p>
                    </div>
                </div>
                <div data-aos="fade-up" className="context context-final">
                    <picture>
                        <source srcSet="../images/time.webp" type="image/webp"></source>
                        <source srcSet="../images/time-min.png" type="image/png"></source>
                        <img src=" ../images/time-min.png" alt="timer" className="sol-img"></img>
                    </picture>
                    <div className="context-box">
                        <p className="context-title">Lack of time and strategy</p>
                        <p className="context-description">Most of the people don't have time and proper strategy to track live
                            markets.</p>
                    </div>
                </div>
            </section>

            <section className="usp">
                <h1 data-aos="fade-up" className="section-heading">Unique Selling Proposition</h1>
                <div data-aos="fade-up" className="context  flip">
                    <picture>
                        <source srcSet="../images/robo-algo.webp" type="image/webp"></source>
                        <source srcSet="../images/robo-algo-min.png" type="image/png"></source>
                        <img src=" ../images/robo-algo-min.png" alt="No others have ai trading algo" className="sol-img"></img>
                    </picture>
                    <div className="context-box">
                        <p className="context-description">None of the other algo trading platforms are providing algorithms
                            developed with machine learning</p>
                    </div>
                </div>
                <div data-aos="fade-up" className="context">
                    <picture>
                        <source srcSet="../images/platform.webp" type="image/webp"></source>
                        <source srcSet="../images/platform-min.png" type="image/png"></source>
                        <img src=" ../images/platform-min.png" alt="No others have ai trading algo" className="sol-img"></img>
                    </picture>
                    <p className="context-description context-box">All other trading platforms provide tools like indicators and
                        price
                        action-based strategies which are not more reliable.</p>
                </div>
                <div data-aos="fade-up" className="context context-final flip">
                    <picture>
                        <source srcSet="../images/analysis.webp" type="image/webp"></source>
                        <source srcSet="../images/analysis-min.png" type="image/png"></source>
                        <img src=" ../images/analysis-min.png" alt="Analysis" className="sol-img"></img>
                    </picture>
                    <p className="context-description context-box">The problem with indicators and price action is that the big
                        players can
                        also see all these things on their charts. Thus they tend to provide false signals to trade upon.
                    </p>
                </div>
            </section>
        </div>
    )
}
export default HomePage
